import { PUBLIC_ROUTES, PUBLIC_ROUTES_WITH_ONE_PATH_PARAM_AT_END } from '../constants/app';
import { ROUTE_POSTFIX, ROUTE_PREFIX, ROUTE_FETCH_ROOT } from '../constants/routes';

export const getRouteAfterRemovingPathParamAtEnd = (route: string) => {
    return route.substring(0, route.lastIndexOf('/') + 1)
}

export const isPublicRouteWithOnePathParamAtEnd = (route: string): boolean => {
    // We need to normalize both the route and the public routes to ensure consistent comparison
    const normalizedRoute = normalizePath(route);
    return !!PUBLIC_ROUTES_WITH_ONE_PATH_PARAM_AT_END.find((publicRoute) => 
        getRouteAfterRemovingPathParamAtEnd(publicRoute) === getRouteAfterRemovingPathParamAtEnd(normalizedRoute)
    );
}

export const getRouteAfterRemovingPostfix = (route: string, postFix: string = ROUTE_POSTFIX): string => {
    return route.replace(postFix, "")
}

export const getRouteAfterRemovingPrefix = (route: string, prefix: string = ROUTE_PREFIX): string => {
    return route.replace(prefix, "")
}

export const getRouteAfterRemovingPrefixAndPostfix = (route: string, prefix: string = ROUTE_PREFIX): string => {
    return getRouteAfterRemovingPostfix(getRouteAfterRemovingPrefix(route, prefix));
}

export const getRouteAfterRemovingQueryParams = (route: string): string => {
    return route.split('?')[0];
} 

// Helper function to normalize paths by removing trailing slashes (except for root path)
const normalizePath = (pathname: string): string => {
    if (!pathname) return '';
    // Remove trailing slash if it's not the root path itself
    return pathname.length > 1 && pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

export const isPublicRoute = (route: string): boolean => {
    const normalizedRoute = normalizePath(route);
    const result = PUBLIC_ROUTES.includes(normalizedRoute) || isPublicRouteWithOnePathParamAtEnd(normalizedRoute);
    console.log("🔍 isPublicRoute check for:", route, "Normalized:", normalizedRoute, "Result:", result, "PUBLIC_ROUTES:", PUBLIC_ROUTES);
    return result;
}
